import React, {useMemo} from 'react';
import {useTheme} from '@mui/material';
import {Layout} from 'components/layout';

type Props = {
  spacing?: string | number;
  indentation?: string | number;
  colorx?: string;
};

const makeBorder = (colorx: string) => `0.5px solid ${colorx}`;

export const Ruler: React.FC<Props> = ({spacing, indentation, colorx}) => {
  const {colors} = useTheme();
  const sx = useMemo(
    () => ({
      border: makeBorder(colorx ?? colors.beige),
    }),
    [colorx, colors],
  );

  return (
    <Layout flex={1}>
      <Layout my={spacing} mx={indentation} flex={1} sx={sx} />
    </Layout>
  );
};
